import axios from 'axios';

const state = {
    all: {}
};

const mutations = {
    load(state, providers){
        for(const provider of providers){
            state.all[provider.id] = provider;
        }
    }
};

const actions = {
    load({commit}){
        return axios.get('/providers').then(response => commit('load', response.$data));
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
